// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const EventIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="EventIcon" ref={forwardedRef} {...props}>
      <path d="M5 10a4 4 0 0 1 4-4h2a4 4 0 0 1 4 4v4h1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h1zm4-2.5A2.5 2.5 0 0 0 6.5 10v3.995h7V10A2.5 2.5 0 0 0 11 7.5zm-4.5 9h11v-1h-11z" />
      <path d="M9.25 5V2h1.5v3z" />
      <path d="m16.621 3.629 1.061 1.06-2.121 2.122L14.5 5.75z" />
      <path d="M3.379 3.629 5.5 5.75 4.44 6.81 2.317 4.69z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const EventIcon = /* @__PURE__ */ Object.assign(EventIconComponent, {
  displayName: 'EventIcon',
});
